import dynamic from "next/dynamic";
import {
  ItemWrapper,
  Image,
  DescriptionWrapper,
  Title,
  LinkWrapper,
} from "./styles";

const Link = dynamic(() => import("../link/link"));

export const PathologiesItem = ({ image, title, description, link }) => {
  return (
    link ? (
      <Link {...link} noUnderline>
        <ItemWrapper>
          {image && <Image media={image} />}
          <DescriptionWrapper>
            {title && <Title>{title}</Title>}
          </DescriptionWrapper>
        </ItemWrapper >
      </Link>

    ) :
      (
        <ItemWrapper>
          {image && <Image media={image} />}
          <DescriptionWrapper>
            {title && <Title>{title}</Title>}
          </DescriptionWrapper>
        </ItemWrapper >
      )

  );
};

export default PathologiesItem;
